import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Alert from '../utils/Alerts';
import { API_URL } from './utiles/ApiConfig';

const AdminManagement = () => {
  const [admins, setAdmins] = useState([]);
  const [editAdmin, setEditAdmin] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [alert, setAlert] = useState(null);

  const showAlert = (variant, title, message) => {
    setAlert({ variant, title, message });
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  };

useEffect(() => {
  fetchAdmins();
}, []);

const fetchAdmins = async () => {
  try {
    const loggedInEmail = localStorage.getItem('email');
    const response = await axios.get(`${API_URL}/admin/admin/list`);
    const filteredAdmins = response.data.admins.filter(
      (admin) => admin.email !== loggedInEmail
    );
    setAdmins(filteredAdmins);
  } catch (error) {
    showAlert('failed', 'Error', 'Failed to fetch admins');
  }
};


  const deleteAdmin = async (admin_id) => {
    try {
      await axios.delete(`${API_URL}/admin/admin/delete`, {
        data: { admin_id },
      });
      showAlert('success', 'Deleted', 'Admin deleted successfully');
      fetchAdmins();
    } catch (error) {
      showAlert('failed', 'Error', 'Failed to delete admin');
    }
  };

  const handleProfileUpdate = async () => {
    const { username, email, phoneNumber } = editAdmin;
    if (!username || !email || !phoneNumber) {
      return showAlert('warning', 'Required', 'All fields are required');
    }

    try {
      await axios.put(`${API_URL}/admin/admin/update-profile`, {
        admin_id: editAdmin._id,
        username,
        email,
        phoneNumber,
      });
      setEditAdmin(null);
      showAlert('success', 'Updated', 'Admin profile updated');
      fetchAdmins();
    } catch (error) {
      showAlert('failed', 'Error', 'Failed to update admin');
    }
  };

  const handlePasswordUpdate = async () => {
    if (!newPassword) {
      return showAlert('warning', 'Required', 'Password cannot be empty');
    }

    try {
      await axios.put(`${API_URL}/admin/update-password`, {
        admin_id: editAdmin._id,
        newPassword,
      });
      setNewPassword('');
      showAlert('success', 'Updated', 'Password updated');
    } catch (error) {
      showAlert('failed', 'Error', 'Failed to update password');
    }
  };

  return (
    <div className="max-full mx-auto px-4 py-6 text-[15px]">
      <h1 className="text-2xl font-semibold mb-4 text-center">Admin Management</h1>

      {alert && (
        <Alert variant={alert.variant} title={alert.title} message={alert.message} />
      )}

      <div className="h-[90vh] overflow-y-scroll pr-1 space-y-4">
        {admins.map((admin) => (
          <div
            key={admin._id}
            className="bg-white rounded-md shadow-sm p-4 border border-gray-200"
          >
            {editAdmin && editAdmin._id === admin._id ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3">
                  <input
                    type="text"
                    value={editAdmin.username}
                    onChange={(e) => setEditAdmin({ ...editAdmin, username: e.target.value })}
                    placeholder="Username"
                    className="w-full px-3 py-[6px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-[15px]"
                  />
                  <input
                    type="email"
                    value={editAdmin.email}
                    onChange={(e) => setEditAdmin({ ...editAdmin, email: e.target.value })}
                    placeholder="Email"
                    className="w-full px-3 py-[6px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-[15px]"
                  />
                  <input
                    type="text"
                    value={editAdmin.phoneNumber}
                    onChange={(e) => setEditAdmin({ ...editAdmin, phoneNumber: e.target.value })}
                    placeholder="Phone"
                    className="w-full px-3 py-[6px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-[15px]"
                  />
                </div>

                <div className="flex flex-wrap gap-2 mb-3">
                  <button
                    onClick={handleProfileUpdate}
                    className="bg-blue-600 text-white px-4 py-[6px] rounded hover:bg-blue-700 transition text-[14px]"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setEditAdmin(null)}
                    className="bg-gray-300 text-gray-800 px-4 py-[6px] rounded hover:bg-gray-400 transition text-[14px]"
                  >
                    Cancel
                  </button>
                </div>

                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="password"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="flex-1 px-3 py-[6px] border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-[15px]"
                  />
                  <button
                    onClick={handlePasswordUpdate}
                    className="bg-green-600 text-white px-4 py-[6px] rounded hover:bg-green-700 transition text-[14px]"
                  >
                    Update Password
                  </button>
                </div>
              </>
            ) : (
              <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">
                <div>
                  <p className="font-medium text-[16px]">{admin.username}</p>
                  <p className="text-gray-600">{admin.email}</p>
                  <p className="text-gray-600">📞 {admin.phoneNumber}</p>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setEditAdmin(admin)}
                    className="bg-blue-500 text-white px-4 py-[6px] rounded hover:bg-blue-600 transition text-[14px]"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => deleteAdmin(admin._id)}
                    className="bg-red-500 text-white px-4 py-[6px] rounded hover:bg-red-600 transition text-[14px]"
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminManagement;
